import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"

const PardanKarmaReport = (props) => {
  return (
    <>
      <TableContainer classes={{ root: "fixed-head-table-container" }}  >
        <Typography variant="body1" className="report-heading">प्रधानकर्म प्रतिवेदन</Typography>
        <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Ksharasutra-Sewa-Report">
          <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
            <TableRow>
              <TableCell rowSpan={2}> सेवाको विवरण</TableCell>
              <TableCell>लिङ्ग</TableCell>
              <TableCell>वमन</TableCell>
              <TableCell>विरेचन</TableCell>
              <TableCell>निरुह वस्ति</TableCell>
              <TableCell>अनुवासन वस्ति</TableCell>
              <TableCell>नस्य</TableCell>
              <TableCell>रक्तमोक्षण</TableCell>
            </TableRow>
          </TableHead>
          <TableBody classes={{ root: "align-center" }}>
            <TableRow>
              <TableCell rowSpan={2}>सेवाग्राही संख्या </TableCell>
              <TableCell>महिला</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.PATIENT_COUNT?.FEMALE?.[5]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.PATIENT_COUNT?.FEMALE?.[6]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.PATIENT_COUNT?.FEMALE?.[7]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.PATIENT_COUNT?.FEMALE?.[8]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.PATIENT_COUNT?.FEMALE?.[9]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.PATIENT_COUNT?.FEMALE?.[10]}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>पुरुष</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.PATIENT_COUNT?.MALE?.[5]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.PATIENT_COUNT?.MALE?.[6]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.PATIENT_COUNT?.MALE?.[7]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.PATIENT_COUNT?.MALE?.[8]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.PATIENT_COUNT?.MALE?.[9]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.PATIENT_COUNT?.MALE?.[10]}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell rowSpan={2}>सेवा संख्या </TableCell>
              <TableCell>महिला</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.SERVICE_COUNT?.FEMALE?.[5]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.SERVICE_COUNT?.FEMALE?.[6]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.SERVICE_COUNT?.FEMALE?.[7]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.SERVICE_COUNT?.FEMALE?.[8]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.SERVICE_COUNT?.FEMALE?.[9]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.SERVICE_COUNT?.FEMALE?.[10]}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>पुरुष</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.SERVICE_COUNT?.MALE?.[5]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.SERVICE_COUNT?.MALE?.[6]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.SERVICE_COUNT?.MALE?.[7]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.SERVICE_COUNT?.MALE?.[8]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.SERVICE_COUNT?.MALE?.[9]}</TableCell>
              <TableCell>{props?.tableData?.PRADHAN_KARMA?.SERVICE_COUNT?.MALE?.[10]}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default PardanKarmaReport;